import React, { type PropsWithChildren, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export default function RoutingRedirect({ children }: PropsWithChildren<unknown>) {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      history.replace(location.hash.replace('#', ''));
    }
  }, [history, location.hash, location.pathname]);

  return <>{children}</>;
}
